/* istanbul ignore file */

import { AppCategoryOption, Discipline } from '../../../models';

export class AppCategoriesServiceModel {
    disciplines: Discipline[] = [];
    isLoaded = false;
    isLoading = false;
    useCases: AppCategoryOption[] = [];
}
